import { ca } from '@cian/analytics';

export const trackProfessionalSearchClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'main_page',
    action: 'top_menu',
    label: 'ListingLK',
  });
};
